module.exports = __webpack_public_path__ + "img/football.e003418a.jpg";